import styled from 'styled-components'

export const Section = styled.section`
  background-color: #f9f6ef;
`

export const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;

  padding-top: 47px;
  padding-left: 42px;
  padding-right: 42px;
`

export const PlanSelectorWrapper = styled.div`
  margin-top: 61px;
`

export const Title = styled.h2`
  font-family: ${( props ) => props.theme.fontFamily.robotoSlab};
  color: ${( props ) => props.theme.cores[ 'GREY-700-TXT' ]};

  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0%;
  text-align: center;
`

export const Subtitle = styled.span`
  font-family: ${( props ) => props.theme.fontFamily.notoSans};
  color: ${( props ) => props.theme.cores[ 'GREY-700-TXT' ]};

  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;

  margin-top: 10px;
  text-align: center;
`

export const DeliveryFee = styled.span`
  cursor: pointer;
  color: #999;
  font-size: 14px;
  text-decoration: underline;
  margin-top: 15px;
`

export const CarouselWrapper = styled.div`
  width: 100%;
`

export const BoardWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 21px;

  .plan-card {
    width: 100%;
    max-width: 360px;
  }

  .price-wrapper {
    padding: 0 50px;
    width: 307px;
  }
`

export const WrapperWantBoth = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px ;
  padding-left: 46px;
  padding-right: 46px;
`

export const ButtonWantBoth = styled.button`
  display: flex;
  justify-content: center;
  color: ${props => props.theme.v2.palette[ 'TAG1-700' ]};
  border-color: ${props => props.theme.v2.palette[ 'TAG1-700' ]};
  cursor: pointer;

  background-color: transparent;
  border: 1px solid;
  max-width: 275px;

  width: 275;
  height: 40px;
  border-radius: 8px;
  border-width: 1px;
  padding-top: 11px;
  padding-right: 31px;
  padding-bottom: 11px;
  padding-left: 31px;
  gap: 8px;


  font-family: ${props => props.theme.fontFamily.notoSans};
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 1%;

  @media(max-width: ${props => props.theme.mediaQuery.smallpc}) {
    width: 100%;
  }
`
